import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { equals, head, without, difference } from 'ramda'
import * as request from 'services/request'
import notify from 'utils/notification'
import MediaThumbnail from './media-thumb'

const MEDIA_MAX_THUMB_WIDTH = 250

const MediaPreviewContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  border: 1px solid #c2cad8;
  margin-top: -1px;
  padding: 8px;
`

class MediaThumbnails extends Component {
  constructor (props) {
    super(props)

    this.state = {
      media: []
    }

    this.removeMedia = this.removeMedia.bind(this)
  }

  async componentDidMount () {
    const mediaIds = this.props.input.value

    this.setState({
      media: mediaIds.map(id => ({
        type: 'loading',
        id
      }))
    })

    const previews = await this.getMedia(mediaIds)

    this.setState({ media: previews })
  }

  async componentDidUpdate (prevProps, prevState) {
    const prevIds = prevProps.input.value
    const currentIds = this.props.input.value

    if (!equals(prevIds, currentIds)) {
      await this.fetchNewMedia(prevIds)
    }
  }

  async fetchNewMedia (prevIds) {
    const currentMedia = this.state.media
    const currentIds = this.props.input.value

    // we need to keep all previews that were not removed when the props changed
    const media = currentMedia.filter(p => currentIds.includes(p.id))
    // then we collect the new ids to fetch them from the backend
    const newIds = difference(currentIds, prevIds)

    // add a temporary loader for the new ids
    const loadingMedia = media.concat(
      newIds.map(id => ({
        type: 'loading',
        id
      }))
    )

    this.setState({
      media: loadingMedia
    })

    const newMedia = await this.getMedia(newIds)

    this.setState({
      media: media.concat(newMedia)
    })
  }

  async constructMedia ({ response, id }) {
    const { headers } = response

    const isJson = equals('application/json')(headers.get('content-type'))
    let data
    if (isJson) {
      // media is either gif or video
      const json = await response.json()
      data = head(json)
    } else {
      // media is an image
      const blob = await response.blob()
      const url = window.URL.createObjectURL(blob)
      data = url
    }

    return {
      data,
      name: headers.get('x-file-name'),
      type: headers.get('x-file-type'),
      id
    }
  }

  getMedia (ids, /* istanbul ignore next */ authorized = request.authorized) {
    return Promise.all(
      ids.map(async id => {
        try {
          const response = await authorized(
            `/media/${id}?w=${MEDIA_MAX_THUMB_WIDTH}`
          )

          return this.constructMedia({ id, response })
        } catch (error) {
          notify.error({
            title: `Error loading media`,
            message: `Could not load media id '${id}': ${error.message}`
          })

          return {
            type: 'error',
            id
          }
        }
      })
    )
  }

  removeMedia (id) {
    // update widget data stored in redux form
    const widgetMedia = without(id, this.props.input.value)
    this.props.input.onChange(widgetMedia)
  }

  render () {
    const { media } = this.state
    if (!media || !media.length) return null

    return (
      <MediaPreviewContainer className='br-media-preview-container'>
        {media.map(item => (
          <MediaThumbnail
            className='br-media-thumb'
            key={item.id}
            {...item}
            removeMedia={this.removeMedia}
          />
        ))}
      </MediaPreviewContainer>
    )
  }
}

MediaThumbnails.propTypes = {
  input: PropTypes.any
}

export default MediaThumbnails



// WEBPACK FOOTER //
// ./src/pages/widgets/form/tweet-input/media/media-thumbnails.js